import * as React from "react";

function Facebook(props) {
  return (
    <svg
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      aria-label="Facebook logo"
    >
      <circle cx={15} cy={15.005} r={15} fill="#1877F2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.838 19.34l.665-4.336h-4.16V12.19c0-1.186.581-2.342 2.445-2.342h1.891V6.156s-1.716-.293-3.358-.293c-3.426 0-5.666 2.077-5.666 5.836v3.305H8.846v4.336h3.81v10.483a15.116 15.116 0 004.687 0V19.34h3.495"
        fill="#fff"
      />
    </svg>
  );
}

export default Facebook;